const pluralize = (value, word, end, plural = `${word}${end || 's'}`) => ([1, -1].includes(Number(value)) ? word : plural)

export default pluralize
